function getReverseColor(color) {
  let input = color;
  if (!color || !/^#.*/.test(color)) {
    return false;
  }
  //format
  if (color.length === 4) {
    input =
      "#" + color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
  }

  let inputValue = "0x" + input.replace(/#/g, "");
  let outValue = "000000" + (0xffffff - inputValue).toString(16);
  return "#" + outValue.substring(outValue.length - 6, outValue.length);
}
module.exports = getReverseColor;



// WEBPACK FOOTER //
// ./ecology9/wea-tools/color.js